const ConsumerProductService = () => {
    /**
     * A list of colors used for consumer products.
     */
    const COLORS = ['#FFFDDF', '#DFEDFB', '#E6FDE5', '#F4DBF0', '#DFD8F9'];

    return {
        /**
         * A list of colors used for consumer products.
         */
        COLORS,

        /**
         * Get color for index.
         */
        colorForIndex: (index: number) => {
            return COLORS[index % COLORS.length];
        }
    };
};

export default ConsumerProductService();
